<template>
	<v-currency-field
		:hide-details="hideDetails"
		:error="errorBorder"
		:error-messages="$props.error"
		:label="$props.label"
		:mask="$props.mask"
		:placeholder="$props.placeholder"
		:readonly="$props.readonly"
		:type="$props.type"
		v-bind="currency_config"
		v-model="inputValue"
	></v-currency-field>
</template>

<script>
export default {
	name: 'CurrencyField',
	props: {
		value: Number,
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
		precision: {
			type: Number,
			default: 2,
		},
		placeholder: String,
		label: String,
		type: String,
		mask: String,
		readonly: Boolean,
	},
	data() {
		return {
			inputValue: this.$props.value,
			currency_config: {
				locale: 'hr',
				prefix: '',
				suffix: '',
				decimalLength: this.$props.precision,
				masked: false,
				min: Number.MIN_SAFE_INTEGER,
				max: Number.MAX_SAFE_INTEGER,
				defaultValue: null,
			},
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},
	watch: {
		inputValue() {
			this.$emit('input', this.inputValue);
		},
	},
};
</script>

<style scoped></style>
